(ns hai.ui.components.spinners
  "Customizable spinner components"
  (:require
   [lambdaisland.ornament :as o]
   #?@(:clj [[garden.stylesheet :as gs]])
   #?@(:cljs [[hai.ui.components :as c]]))
  #?(:cljs
     ;; Ensure the clj namespace is initialized, because we use clojure.core/str
     ;; calls inside the CSS portion
     (:require-macros hai.ui.components.spinners)))

(o/defprop --color-1 "var(--gray-5)")
(o/defprop --color-2 "var(--gray-10)")
(o/defprop --size "12px")

#?(:clj
   (o/defrules shadow-pulse
     (gs/at-keyframes
      :shadow-pulse
      [:33% {:background --color-1
             :box-shadow (str "calc("--size " * -2) 0 " --color-2 ", "
                              "calc("--size " *  2) 0 " --color-1)}]
      [:66% {:background --color-2
             :box-shadow (str "calc("--size " * -2) 0 " --color-1 ", "
                              "calc("--size " *  2) 0 " --color-1)}]
      [:100% {:background --color-1
              :box-shadow (str "calc("--size " * -2) 0 " --color-1 ","
                               "calc("--size " *  2) 0 " --color-2)}])))

(o/defstyled pulse-dots :span
  {:width --size
   :height --size
   :border-radius "50%"
   :display "block"
   :margin (str "calc("--size " - 1px) auto")
   :position "relative"
   :background --color-1
   :box-shadow (str "calc("--size " * -2) 0 " --color-1 ", "
                    "calc("--size " *  2) 0 " --color-1)
   :box-sizing "border-box"
   :animation "shadow-pulse 2s linear infinite"})

(o/defstyled dots :div
  {:width (str "calc("--size "* 5)")
   :display "inline-block"}
  ([]
   [:<> [pulse-dots]]))

#?(:clj
   (o/defrules logo-spin-animation
     (gs/at-keyframes
      :logoSpin
      [:0% {:transform "rotate(0deg) scale(1)"}]
      [:50% {:transform "rotate(180deg) scale(1.1)"}]
      [:100% {:transform "rotate(360deg) scale(1)"}])))

#?(:clj
   (o/defrules dot-fade-animation
     (gs/at-keyframes
      :dotFade
      [:0% {:opacity 0.2}]
      [:20% {:opacity 1}]
      [:100% {:opacity 0.2}])))

#?(:cljs
   (o/defstyled streaming-dots :div
     :pl-4 :flex :items-center :gap-2
     [:.dots :flex :gap-1 :items-center
      [:.dot :w-2 :h-2 :rounded-full
       {:background c/--gray-9
        :animation "dotFade 1.4s ease-in-out infinite"}]
      [:.dot:nth-child-1
       {:animation-delay "0s"}]
      [:.dot:nth-child-2
       {:animation-delay "0.2s"}]
      [:.dot:nth-child-3
       {:animation-delay "0.4s"}]]
     [:svg :w-8
      {:animation "logoSpin 2s ease-in-out infinite"}]
     ([& children]
      [:<>
       (when children
         children)
       [:div.dots
        [:div.dot]
        [:div.dot]
        [:div.dot]]])))
